
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startups/intro",
      function () {
        return require("private-next-pages/startups/intro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startups/intro"])
      });
    }
  